<template>
    <ul class="kt-menu__nav">
        <template v-for="(menu, i) in menuItems">
            <KTMenuItem v-bind:menu="menu" :key="i"></KTMenuItem>
        </template>
    </ul>
</template>

<script>
import KTMenuItem from "@/views/theme/header/MenuItem.vue";

export default {
    name: "KTHeaderMenu",
    components: {
        KTMenuItem
    },
    computed: {
        menuItems: () => {
            return [];
        }
    }
};
</script>
